<template>
  <div class="container-fluid">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data"></bread-crumb>

    <b-tabs v-model="tab.tabIndex" class="mb-4">
      <b-tab
        v-for="(item, index) in tab.items"
        :key="index"
        :title="item.label" />
    </b-tabs>

    <section class="btn-area">
      <div
        class="btn-box"
        v-for="(item, index) in print.batchDownload.filter(item => item.printStatus === tab.tabIndex)"
        :key="index"
      >
        <b-button
          variant="primary"
          @click="item.clickFunction"
        >
          {{ item.label }}
        </b-button>
      </div>
    </section>

    <html-to-pdf
      v-if="status.resetDom"
      ref="htmlToPdf"
      :enableDownload="true"
      :isIframePreviewPdf="false"
      :filename="print.filename"
      @handlerCompleted="pdfCompleted"
    >
      <template slot="pdf-content">
        <bill
          v-for="(item, index) in print.list"
          :key="index"
          :data="item" />
      </template>
    </html-to-pdf>
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import billApi from "@/models/API/billApi";
import HtmlToPdf from '@/components/common/HtmlToPdf';
import Bill from '@/components/common/PrintTemplate/Bill';

export default {
  name: 'currentMonthBill',
  components: {
    BreadCrumb,
    Bill,
    HtmlToPdf
  },
  data () {
    return {
      isLoading: false,
      list: [],
      domList: [],
      // list: ['1'],
      view: {
        bread_crumb_data: [
          { name: '帳單管理', url: '', isActive: true },
          { name: '當月全部未繳帳單', url: '', isActive: false }
        ]
      },
      data: {
        temp_table_data: {},
      },
      status: {
        resetDom: false
      },
      tab: {
        items: [
          {
            label: '不印',
            value: 0
          },
          {
            label: '要印',
            value: 1
          },
        ],
        tabIndex: 1
      },
      options: {
        receive: [
          {
            label: '郵寄',
            value: 0,
            printStatus: 1
          },
          {
            label: '通知業務',
            value: 1,
            printStatus: 0
          },
          {
            label: '自取',
            value: 2,
            printStatus: 1
          },
          {
            label: '萬事達-郵寄',
            value: 3,
            printStatus: 0
          },
          {
            label: '萬事達-自取',
            value: 4,
            printStatus: 0
          },
          {
            label: '萬事達-特殊',
            value: 5,
            printStatus: 0
          },
          {
            label: '自動扣款',
            value: 6,
            printStatus: 0
          },
          {
            label: '墊繳',
            value: 7,
            printStatus: 0
          },
          {
            label: '特殊',
            value: 8,
            printStatus: 1
          },
          {
            label: '不印帳單',
            value: 9,
            printStatus: 0
          },
          {
            label: '萬事達-不印帳單',
            value: 10,
            printStatus: 0
          },
          {
            label: '臨時用',
            tmp: 1,
            printStatus: 0
          }
        ],
      },
      print: {
        perPage: 40,
        total: 0,
        list: [],
        batchDownload: [],
        filename: ''
      },
    }
  },
  mounted() {
    this.billApi = new billApi();

    this.options.receive.forEach(item => {
      this.getBill(1, true, item);
    })


    // 渲染200頁
    // for (let i = 0; i < 3; i++) {
    //     this.list.push(i);
    // }
  },
  methods: {
    // 查詢帳單
    getBill(pageIndex = 1, baseInfo = false, receive = {}, filename = `${new Date().getTime()}`) {
      const params = {
        'receive': receive.value,
        'tmp': receive.tmp,
        'class': 1,
        'PageSize': baseInfo ? 1 : this.print.perPage,
        'PageIndex': pageIndex,
      };
      this.billApi.getBill(async (response) => {
        const res = response.data;


        if (baseInfo) {
          this.print.total = res.total;
          this.generateButton(receive);
        } else {
          this.status.resetDom = true;
          this.print.list = res.data;
          await this.$nextTick();

          this.print.filename = filename;
          this.generateBill();
        }
      }, params)
    },
    // 產生按鈕
    generateButton(receive) {
      const total = this.print.total;
      const perPage = this.print.perPage;
      const button_count = Math.ceil(total / perPage);

      for(let i = 0; i< button_count; i++) {
        const start_count = i * perPage + 1;
        const end_count = i * perPage + perPage >= total ?  total : i * perPage + perPage;
        const num = i + 1 < 10 ? `0${i + 1}` : i + 1;
        this.print.batchDownload.push({
          'clickFunction': () => this.getBill(i + 1, false, receive, `${receive.label}${num}`),
          'label': `${receive.label}${num}`,
          'printStatus': receive.printStatus
        })
      }
    },
    // 產生帳單(PDF)
    generateBill() {
      //  this.$refs.htmlToPdf.getPdf();
      this.$refs.htmlToPdf.generatePdf();
    },
    // PDF產生完成
    pdfCompleted () {
      this.$set(this.status, 'resetDom', false);
      this.$forceUpdate();
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-area {
  display: flex;
  align-items: center;
  justify-self: flex-start;
  flex-wrap: wrap;
  row-gap: 10px;
  column-gap: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/currentMonthBill.vue